import { render, staticRenderFns } from "./PassengerDetails.vue?vue&type=template&id=3fde8e03"
import script from "./PassengerDetails.vue?vue&type=script&lang=js"
export * from "./PassengerDetails.vue?vue&type=script&lang=js"
import style0 from "./PassengerDetails.vue?vue&type=style&index=0&id=3fde8e03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports